import React from "react";
import { ensure, Text } from "sprint-common-web";

export const renderTargetFilenames = <T extends { targetFilenames: string[] }>(item?: T): JSX.Element => {
    ensure(item);

    return (
        <>
            {item.targetFilenames.map((filename) => (
                <Text variant="smallPlus" key={filename} tooltip={filename}>
                    {filename}
                </Text>
            ))}
        </>
    );
};
